
// Libraries
var React = require('react');

// Styles
require('./SearchInput.scss');

// Assets
var searchIcon = require('images/search.svg');

class SearchBarMobile extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			inputValue: '',
			defaultMParticleEventObject: (typeof window !== "undefined") ? window.defaultMParticleEventObject : null
		};
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
	}

	render() {
		return (
			<div className="SearchInput">
				<form action={this.props.url} method="get" onSubmit={this.handleFormSubmit}>
					<label htmlFor={`searchInput${this.props.label}`} className="u-visually-hidden">Search input</label>
					<input id={`searchInput${this.props.label}`} value={this.state.inputValue} onChange={this.handleInputChange} type="text" name={this.props.fields[0].name} placeholder={this.props.fields[0].placeholder} ref={this.props.inputRef} />
					<button type="submit"><img src={searchIcon} alt={this.props.fields[0].label} /></button>
				</form>
			</div>
		)
	}

	handleInputChange(e) {

		this.setState({ inputValue: e.target.value });

	}

	handleFormSubmit(e) {

		if (this.state.defaultMParticleEventObject !== null) {

			const eventData = {
				event: 'content_searched',
				search_keyword: this.state.inputValue,
				search_type: 'site_search'
			};

			const eventDataMerged = { ...this.state.defaultMParticleEventObject, ...eventData };

			window.dataLayer.push(eventDataMerged);

		}

	}

}

module.exports = SearchBarMobile;



// WEBPACK FOOTER //
// ./src/components/Search/SearchInput/SearchInput.js